<template>
  <LibraryLayout :title="'Idea Library'" :items="ideas">
    <template slot="button">
      <v-btn v-if="authUser" @click="createIdea" color="secondary" class="black--text elevation-0">
        <v-icon left>mdi-creation-outline</v-icon> Create Idea
      </v-btn>
      <v-btn v-else @click="go('LoginView')" color="secondary" class="black--text elevation-0">
        <v-icon left>mdi-lock-outline</v-icon> Create Idea
      </v-btn>
    </template>
    <template #card="{ item: idea }">
      <v-card class="ma-2" width="300" @click="go('IdeaPlayer', idea.id)">
        <v-img :src="idea.thumbnail" color="grey lighten-4" height="200"></v-img>
        <v-divider></v-divider>
        <div class="px-4 pt-4 cal-sans-regular font-size-20">{{ idea.title }}</div>
        <div class="d-flex flex-row align-center px-4 pb-4 pt-2">
          <v-avatar size="30">
            <v-img src="@/assets/babyboomy.png"></v-img>
          </v-avatar>
          <p class="ma-0 ml-2">Baby Boomy</p>
        </div>
      </v-card>
    </template>
  </LibraryLayout>
</template>

<script>
import { getDocs, collection } from 'firebase/firestore'
import { db } from '@/firebase/init'
import LibraryLayout from '@/layouts/Library.vue'
export default {

  name: 'IdeaLibrary',
  
  components: { LibraryLayout },

  data() {
    return {
      ideas: [],
      progress: 0,
    }
  },

  created() {
    this.loadIdeas()
  },

  methods: {
    loadIdeas() {
      this.progress = 0
      const ideasRef = collection(db, 'ideas')
      getDocs(ideasRef).then((snapshot) => {
        snapshot.forEach((doc) => {
          let idea = doc.data()
          idea.id = doc.id
          this.ideas.push(idea)
        })
        this.progress = 100
      })
    },
    async createIdea() {
      if (this.authUser) {
        await this.$creator.create('idea', this.profile);
      }
    }
  }
}
</script>

<style scoped>

</style>